<template>
    <BottomModal
        :is-visible="modalStore.activeModal === MODAL_CITE"
        class="cite-modal"
        title="Cite this video"
        description="Copy a reference to this video in Vancouver style"
        @close="modalStore?.closeModal"
    >
        <div class="cite-modal__citation">
            {{ citation }}
        </div>
        <BaseButton 
            :icon-left="copied ? 'check' : 'content-copy'"
            class="base-button--wide"
            gtm-copy-citation
            @click="copyCitation"
        >
            {{ copied ? 'Citation copied' : 'Copy citation' }}
        </BaseButton>
    </BottomModal>
</template>

<script setup>
import { useModalStore, MODAL_CITE } from '~/store/modal';

const modalStore = useModalStore();


const props = defineProps({
    video: {
        type: Object,
        required: true
    }
});

const copied = ref(false);

const citation = ref(`${props.video.user.last_name} ${props.video.user.first_name.charAt(0)}. ${props.video.title}. MedPeers ${props.video?.specialisations[0].title}; ${new Date().getFullYear()}. Available from: https://www.medpeers.org/videos/${props.video?.id}.`);

function copyCitation() {
    navigator.clipboard.writeText(citation.value);
    copied.value = true;

    setTimeout(() => {
        copied.value = false;
    }, 5000);
}
</script>

<style lang="less">
.cite-modal__citation {
    .input();
    padding: .75rem;
    border-bottom: 1px solid var(--color-muted-gray);
    border-radius: var(--borderRadius-sm);
    text-align: left;
    margin-bottom: 1rem;
    line-height: 1.4;
    word-break: break-all;
}
</style>
